// extracted by mini-css-extract-plugin
export default {"storeButton":"AppStoreButtons_storeButton__TyzuJ","appleButton":"AppStoreButtons_appleButton__9qZAz"};